import { render, staticRenderFns } from "./pilgrimRegistration.vue?vue&type=template&id=57e3a91e&"
import script from "./pilgrimRegistration.vue?vue&type=script&lang=js&"
export * from "./pilgrimRegistration.vue?vue&type=script&lang=js&"
import style0 from "./pilgrimRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports